






























































import { Vue, Component, Prop } from "vue-property-decorator";
import CdkFilterPassBadges from "../../CdkFilterPassBadge/CdkFilterPassBadges.vue";
import SlcNewsItemLong from "../SlcNewsItemLong/SlcNewsItemLong.vue";
import { FilterPassBadge } from "@/utils/filterPassBadges";
import CdkImage from "../ContentRows/CdkImage.vue";

@Component({
  components: {
    CdkFilterPassBadges,
    SlcNewsItemLong,
    CdkImage
  }
})
export default class SlcNewsItemShort extends Vue {
  @Prop() date!: string;

  @Prop() time!: string;

  @Prop() genre!: string;

  @Prop() title!: string;

  @Prop() guid!: string;

  @Prop() isUrgent?: boolean;

  @Prop() isEmbargoed?: boolean;

  @Prop() embargoed?: string;

  @Prop({ type: Boolean, default: false, required: false }) isMobile?: boolean;

  @Prop({ type: Boolean, default: false, required: false }) isActive?: boolean;

  @Prop({
    type: Array,
    required: false,
    default: () => []
  })
  filterPassBadges?: FilterPassBadge[];

  @Prop({
    type: String,
    required: false
  })
  residref: string | null;

  @Prop({
    type: String,
    required: false
  })
  layoutOrientation: string | null;

  @Prop({
    type: Boolean,
    default: false
  })
  showNewBadge: boolean;

  visibilityChanged(isVisible) {
    if (isVisible) {
      this.$store.dispatch("newsItems/fetchImage", {
        isThumbnail: true,
        residref: this.residref,
        guid: this.guid
      });
    }
  }
}
